module.exports = "/_next/static/images/richard-matthews-844053871ef9984f34fda11dd9e4d8db.png";